import gql from "graphql-tag";

// Fires whenever the (singleton) loading shipment starts, is canceled or
// finishes. Used only as a trigger to refetch LOADING_CONCRETE_SHIPMENT (which
// also carries manualOperations and the nested formula), so a minimal selection
// is enough here. Replaces the idle polling of loadingConcreteShipment.
export default gql`
  subscription {
    subscribeToLoadingConcreteShipment {
      id
    }
  }
`;
